import { render, staticRenderFns } from "./page-header.vue?vue&type=template&id=402c3ff9&scoped=true&"
import script from "./page-header.vue?vue&type=script&lang=js&"
export * from "./page-header.vue?vue&type=script&lang=js&"
import style0 from "./page-header.vue?vue&type=style&index=0&id=402c3ff9&lang=scss&scoped=true&"
import style1 from "./page-header.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402c3ff9",
  null
  
)

export default component.exports